import m from "mithril";
import Requester from "../../../shared/request";
import Gateway from "../../../shared/app_settings";
import Toasts from "../../../shared/toasts";
import i18n from "../../../shared/i18n/i18n";
import ModalManager from "../../../shared/modal";
import Modal_Confirm_Delete from "../../../shared/components/modal_confirm_delete";
import Auth from "../../../shared/auth";
import FormUtilities from '../../../shared/utilities/form_utilities';
import RouterService from "../../../shared/services/router.service";
import Modal_Unit_File_History from "../modal_unit_file_history";
import UniqueName from "../../../shared/uniqueName";
import {getUnitActiveStatusSlider} from "../unit_status_slider_util";
import {loadCourses} from "../unit_courses";
import TextEditor from "../../../shared/components/component_text_editor";
import TextUtilities from "../../../shared/utilities/text_utilities";

let saving = false;
let onCoursesClick;
let uploading = false;
let deleting = false;
let loading = false;
let unit;

function saveUnitDetails() {
    if (!FormUtilities.validateFields(".details input") || !TextUtilities.hasVisibleText(unit.instructions)) {
        return;
    }

    saving = true;
    m.redraw();

    Requester.post(Gateway.admin + "units/document/" + unit.id, {
        id: unit.id,
        name: unit.name,
        description: unit.description,
        instructions: unit.instructions,
        acknowledgeRequired: unit.acknowledgeRequired,
        acknowledgeStatement: unit.acknowledgeStatement
    })
        .then(function (result) {
            Toasts.add("success", i18n.t("saved_changes"));
        })
        .catch(function (error) {
            Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
        })
        .finally(function () {
            saving = false;
            m.redraw();
        });
}

function uploadDocument() {
    const fileInput = document.getElementById("document-file-input");
    const file = fileInput?.files[0];

    if (!file) {
        Toasts.add("error", i18n.t("cant_upload"), i18n.t("no_file_selected"));
        return;
    }

    const d = new FormData();
    d.append("file", file, file.name);

    uploading = true;
    m.redraw();

    Requester.upload(Gateway.admin + "units/document/" + unit.id + "/upload-file", d)
        .then(function () {
            Toasts.add("success", i18n.t("saved_changes"), "");
            // After a successful upload, re-fetch the unit to get the new documentPath
            return Requester.get(Gateway.admin + "units/" + unit.id).then(function (result) {
                if (result && result.properties) {
                    unit.documentFileName = result.properties.documentFileName || file.name;
                    unit.documentPath = result.properties.documentPath || unit.documentPath;
                } else {
                    unit.documentFileName = file.name;
                }
            });
        })
        .catch(function (error) {
            Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
        })
        .finally(function () {
            uploading = false;
            m.redraw();
        });
}

function confirmDeleteUnit() {
    ModalManager.open(i18n.t("delete_unit"), [], Modal_Confirm_Delete, {callback: deleteUnit});
}

function deleteUnit() {
    deleting = true;
    m.redraw();

    Requester.delete(Gateway.admin + "units/document/" + unit.id)
        .then(function () {
            RouterService.navigateToUnits();
        })
        .catch(function (error) {
            Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
        })
        .finally(function () {
            deleting = false;
            m.redraw();
        });
}

function showHistory() {
    loading = true;
    m.redraw();

    Requester.get(Gateway.admin + "units/document/" + unit.id + "/history")
        .then(function (result) {
            if (result && result.length > 0) {
                ModalManager.open(i18n.t("history"), ["modal-wide"], Modal_Unit_File_History, {history: result});
            }
            else {
                Toasts.add("warn", i18n.t("no_history_found"));
            }
        })
        .catch(function (error) {
            Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
        })
        .finally(function () {
            loading = false;
            m.redraw();
        });
}

const Component_Unit_Document_Settings = {
    oninit: function (vnode) {
        unit = vnode.attrs.unit;
        onCoursesClick = vnode.attrs.onCoursesClick;
        loadCourses(unit.id);
    },
    view: function () {
        return [
            m(".content-box", [
                m("h3",  i18n.t("details")),
                m(".form .details", {class: !Auth.validateRights(["unit_document_edit"]) ? "disabled" : ""}, [
                    m(".form-section required", [
                        m(".form-label", i18n.t("name")),
                        m("input[type=text]", {
                            onchange: function () {
                                UniqueName.checkUniqueUnitName(unit.id, unit.name);
                            },
                            oninput: function () {
                                unit.name = this.value;
                            }, value: unit.name
                        })
                    ]),
                    m(".form-section", [
                        m(".form-label", i18n.t("description_not_visible_to_learners")),
                        m("textarea", {
                            oninput: function () {
                                unit.description = this.value;
                            }, value: unit.description
                        })
                    ]),
                    m(".form-section required", [
                        m(".form-label", i18n.t("instructions_will_appear_for_learners")),
                        m(TextEditor, {
                            content: encodeURIComponent(unit.instructions || ""),
                            hideHyperlink: true,
                            onchange: function (content) {
                                unit.instructions = content;
                            }
                        }),
                        !TextUtilities.hasVisibleText(unit.instructions) ? m(".text-error.padding", {style: "font-size: 0.75rem;"}, i18n.t("complete_required_fields")) : ""
                    ]),
                    m(".form-section", [
                        m(".form-label", i18n.t("AcknowledgeRequired")),
                        m(".flex-row justify-between", [
                            m(".btn btn-toggle", {
                                onclick: function () {
                                    unit.acknowledgeRequired = !unit.acknowledgeRequired;
                                },
                                class: unit.acknowledgeRequired ? "active" : ""
                            })
                        ])
                    ]),
                    m(".form-section", [
                        m(".form-label", i18n.t("AcknowledgeStatement")),
                        m("textarea", {
                            oninput: function () {
                                unit.acknowledgeStatement = this.value;
                            }, value: unit.acknowledgeStatement
                        })
                    ]),
                    m(".form-buttons", [
                        uploading || saving || UniqueName.unitLoading
                            ? m("button.btn-text no-click", [i18n.t("saving"), m(".loading-dots")])
                            : UniqueName.isUnitNameUnique === false || !unit.name || !TextUtilities.hasVisibleText(unit.instructions)
                                ? m("button.btn-text no-click disabled", i18n.t("save"))
                                : m("button", {onclick: saveUnitDetails}, i18n.t("save"))
                    ])
                ])
            ]),
            m(".content-box", [
                m("h3", i18n.t("content")),
                m(".form", {class: !Auth.validateRights(["unit_document_edit"]) ? "disabled" : ""}, [
                    m(".flex-horizontal-content mb-1", unit.documentFileName ? [
                        m("div.ellipsis", i18n.t("current_file") + ": " + unit.documentFileName),
                        m("button.btn-text", {
                            onclick: showHistory,
                            class: loading ? "disabled loading-dots" : ""
                        }, i18n.t("history"))
                    ] : ""),
                    m(".form-section", [
                        m(".form-label inline-tip", i18n.t("document")),
                        m("div",  i18n.t("supported_file_types_pdf")),
                        m("input[type=file].form-input#document-file-input"),
                        uploading ? [
                            m(".loading-bar mt-1", m(".loading-width"))
                        ] : ""
                    ]),
                    m(".form-buttons", [
                        !saving && !uploading ? m("button", {onclick: uploadDocument}, i18n.t("upload")) : m("button.btn-text no-click", [i18n.t("uploading"), m(".loading-dots")])
                    ])
                ])
            ]),
            m(".content-box", [
                m(".form", {class: !Auth.validateRights(["unit_document_edit"]) ? "disabled" : ""}, [
                    getUnitActiveStatusSlider(unit, saving, onCoursesClick)
                ])
            ]),
            Auth.validateRights(["unit_document_delete"], [
                m(".content-box", [
                    !deleting ? m("button.btn-error", {onclick: confirmDeleteUnit}, i18n.t("delete_unit")) : m("button.btn-text no-click text-error", [i18n.t("deleting"), m(".loading-dots")])
                ])
            ])
        ];
    }
};
export default Component_Unit_Document_Settings;
